import { useState, useEffect, Fragment } from "react";
import dynamic from "next/dynamic";
import parse from "html-react-parser";
import { dehydrate, QueryClient, useQueries } from '@tanstack/react-query';
import { getQueryFn, queryKeyManager } from "../../../utils/api/queryFunction";
import queryConfig from "../../../utils/api/queryConfig";
import { hasProperty } from "../../../utils/validate";

const SEO = dynamic(() => import("../../../components/Shared/SEO"));
const ProductLayout = dynamic(() => import('../../../components/Layout/ProductLayout'));
const SmallBanner = dynamic(() => import('../../../components/Shared/Banners/SmallBanner'));
const FormBuilder = dynamic(() => import('../../../components/Shared/FormBuilder'));

const CallToAction = dynamic(() => import('../../../components/Shared/ShoppingTools/CallToActionTool'))

const FleetPage = props => {
	const { token } = props;

	const [pageDataRes, productsDataRes] = useQueries({
		queries: [
			{
				queryKey: queryKeyManager(["motorcycles", "fleet", "page"], [token]),
				queryFn: () => getQueryFn("motorcycles/fleet", token),
				...queryConfig
			},
			{
				queryKey: queryKeyManager(["motorcycles", "fleet", "products"], []),
				queryFn: () => getQueryFn(`motorcycles/fleet/products`, ""),
				...queryConfig
			}
		]
	});

	if (pageDataRes.isLoading || productsDataRes.isLoading) {
		return <span />
	}

	const pageData = pageDataRes.data;
	const productsData = productsDataRes.data.data;

	const [formData, setFormData] = useState();

	const submitData = (success) => {
		if (success) {
			window.location.href = "/motorcycles/fleet/thank-you";
		} else {
			alert("oops, something went wrong. Please try again later");
		}
	};

	useEffect(() => {
		async function getFormData() {
			if (hasProperty(pageData, "form") && pageData.form != null && pageData.form.handle) {
				let formResponse = await getQueryFn(`form/${pageData.form.handle}`);
				setFormData(formResponse);
			}
		}
		getFormData();
	}, [pageData]);

	return (
		<Fragment>
			<SEO seo={pageData.seo} />
			<ProductLayout nav={pageData.nav.header.links} logo={pageData.nav.header.logos.motorcycles} root="motorcycles" footer={pageData.nav.footer}>
				<SmallBanner banner={pageData.banner} />
				<div className="customContainer mt64px mb64px">

					<div className="productBuilderHolder">
						<div className="productBuilder">
							{/* Add content builder */}
							{hasProperty(pageData, "callToActions") && pageData.callToActions !== null && <CallToAction block={{ data: pageData.callToActions }} setOpenBATD={props.setOpenBATD} getFormData={props.getFormData} key={"cta"} />}
						</div>
					</div>

					<div className="row">
						<div className="col s12 m12 l12 introTitle"><h2>{pageData.introTitle}</h2></div>
						<div className="col s12 m12 l12 mb32px introDescription">
							{pageData.introDescription
								? parse(pageData.introDescription)
								: ""}
						</div>
						<div className="col s12 m12 l12"><h4>Personal Details</h4></div>
					</div>

					{formData &&
						<FormBuilder
							handleSubmit={submitData}
							formData={formData}
							category="motorcycle"
							products={productsData}
							spec={pageData.dealerSpec}
						/>
					}
				</div>
			</ProductLayout>
		</Fragment>
	);
};

FleetPage.getInitialProps = async ({ query, req }) => {
	const { token } = query;
	const queryClient = new QueryClient();

	await queryClient.prefetchQuery({
		queryKey: queryKeyManager(["motorcycles", "fleet", "page"], [token]),
		queryFn: () => getQueryFn("motorcycles/fleet", token),
		...queryConfig
	});

	await queryClient.prefetchQuery({
		queryKey: queryKeyManager(["motorcycles", "fleet", "products"], []),
		queryFn: () => getQueryFn(`motorcycles/fleet/products`, ""),
		...queryConfig
	});

	return {
		token: token,
		dehydratedState: dehydrate(queryClient)
	};
};


export default FleetPage;